import React, {FC, useState, useEffect} from "react"
import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {Label} from "@irati/ui/src/Typography"
import {PerkboxLogo} from "@irati/ui/src/Logos"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import FormattedMessage from "@irati/utils/lang"

import {SelfSignUpScreens} from "../../containers/SignUp"

interface Props {
  screen?: SelfSignUpScreens
  error?: boolean
}

const HeaderFlex = styled(Flex)`
  height: 86px;
  width: 100%;
  padding: 0 ${({theme}) => theme.spacing.five};
  box-shadow: ${({theme}) => theme.shadows.low};
  background: ${({theme}) => theme.colors.greys.white};
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.tablet`
      height: 56px;
      box-shadow: none;
      padding: 0 ${theme.spacing.two};
    `}
  `}
`

const StyledPerkboxLogo = styled(PerkboxLogo)`
  height: 50px;
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.tablet`
      height: 24px;
    `}
  `}
`

const SelfSignUpHeader: FC<Props> = ({screen, error}) => {
  const [progressSaved, setProgressSaved] = useState(false)
  const theme = useTheme()

  useEffect(() => {
    if (
      screen === SelfSignUpScreens.KnowYourBusinessScreen ||
      screen === SelfSignUpScreens.KnowYourCustomerScreen ||
      screen === SelfSignUpScreens.PaymentScreen ||
      screen === SelfSignUpScreens.ConfirmPackageScreen
    ) {
      setProgressSaved(true)
    } else {
      setProgressSaved(false)
    }
  }, [screen])

  return (
    <HeaderFlex justifyContent="space-between" alignItems="center">
      <StyledPerkboxLogo />
      {progressSaved && !error && (
        <Flex justifyContent="center" alignItems="center" gap={1}>
          <Icon icon={IconTypes.circleTickFill} size={16} />
          <Label color={theme.colors.utility.success}>
            <FormattedMessage id="platform.selfSignUp.header.progressSaved" />
          </Label>
        </Flex>
      )}
    </HeaderFlex>
  )
}

export default SelfSignUpHeader
